module.exports = __webpack_public_path__ + "teqbahn-assets/media/slider_3_icon.26696eab.png";